/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitLineupEditsInput = {|
  greenMachineLineupId: string,
  rosterSlots: $ReadOnlyArray<?LineupRosterSlotInput>,
  clientMutationId?: ?string,
|};
export type LineupRosterSlotInput = {|
  lineupRosterSlotId: string,
  slatePlayerId: string,
|};
export type CommitLineupEditsMutationVariables = {|
  input: CommitLineupEditsInput
|};
export type CommitLineupEditsMutationResponse = {|
  +commitLineupEdits: ?{|
    +success: ?boolean
  |}
|};
export type CommitLineupEditsMutation = {|
  variables: CommitLineupEditsMutationVariables,
  response: CommitLineupEditsMutationResponse,
|};
*/


/*
mutation CommitLineupEditsMutation(
  $input: CommitLineupEditsInput!
) {
  commitLineupEdits(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitLineupEditsPayload",
    "kind": "LinkedField",
    "name": "commitLineupEdits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitLineupEditsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitLineupEditsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95d28512709a1151f30ff841b1dc61a8",
    "id": null,
    "metadata": {},
    "name": "CommitLineupEditsMutation",
    "operationKind": "mutation",
    "text": "mutation CommitLineupEditsMutation(\n  $input: CommitLineupEditsInput!\n) {\n  commitLineupEdits(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7428a10c84865d63f24e3bf58285cb9d';

module.exports = node;
